export default class BoundInstances {
  id: string;

  code: string;

  constructor(obj: any) {
    this.id = obj.id || '';
    this.code = obj.code || '';
  }

  public static of(obj: any): BoundInstances {
    return new BoundInstances(obj);
  }

  public static ofList(obj: any[]): BoundInstances[] {
    return obj.map(this.of)
  }
}
